var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _c('tbody', _vm._l(_vm.rows, function (row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('img', {
      staticClass: "personal-website-logo",
      attrs: {
        "src": row.image,
        "alt": "Logo"
      }
    })]), _c('td', [_c('div', {
      staticClass: "site-name"
    }, [_vm._v(_vm._s(row.name))]), _c('div', {
      staticClass: "site-url",
      on: {
        "click": function click($event) {
          return _vm.copyLink(row.domain);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(row.domain))]), _c('i', {
      staticClass: "fa fa-copy copy-icon",
      attrs: {
        "title": "Copy URL"
      }
    })])]), _c('td', [_c('div', {
      staticClass: "actions"
    }, [_c('a', {
      staticClass: "btn ",
      attrs: {
        "href": row.domain,
        "target": "_blank"
      }
    }, [_vm._v("Visit")]), _c('a', {
      staticClass: "btn ",
      on: {
        "click": function click($event) {
          $event.preventDefault();
          return _vm.openEmailModal(row.domain);
        }
      }
    }, [_vm._v("Email")]), _c('button', {
      staticClass: "btn qr-code-btn send-email",
      on: {
        "click": function click($event) {
          $event.preventDefault();
          return _vm.downloadQR(row.domain, row.name);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-qrcode"
    }), _vm._v("QR Code")])])])]);
  }), 0)]), _c('personalized-site-send-email-modal', {
    attrs: {
      "selected-link": _vm.selectedLink
    }
  }), _c('b-modal', {
    attrs: {
      "id": "QRModal",
      "centered": "",
      "hide-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "view-clients-header"
        }, [_c('b-button', {
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }])
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "view-clients-modal-content"
  }, [_c('div', {
    staticClass: "repQR"
  }, [_c('img', {
    attrs: {
      "src": _vm.QRUrl,
      "alt": ""
    }
  }), _c('h4', [_vm._v(_vm._s(_vm.domainName))]), _c('p', [_vm._v(_vm._s(_vm.domainURL))])]), _c('div', {
    staticClass: "repInformation"
  }, [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.$store.getters.rep.name))]), _c('span', {
    staticClass: "repCode"
  }, [_vm._v(_vm._s(_vm.$store.getters.rep.code))])]), _c('div', {
    staticClass: "shareBtn",
    staticStyle: {
      "margin-right": "-15%"
    }
  }, [_c('button', {
    on: {
      "click": function click($event) {
        return _vm.openEmailModal(_vm.domainURL);
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-share-alt"
  }), _vm._v(" Share")])]), _c('div', {
    staticClass: "shareBtn"
  }, [_c('button', {
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.downloadFile();
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-download"
  }), _vm._v(" Download")])])])])])], 1)], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("Logo")]), _c('th', [_vm._v("Site URL")]), _c('th', [_vm._v("Actions")])])]);
}]

export { render, staticRenderFns }